import * as Sentry from '@sentry/nuxt'
import { getCookie, setCookie } from 'h3'

export default defineNuxtRouteMiddleware(async (to) => {
	const refCode = to.query.ref as string | undefined

	const CARBAR_CODE = 'R5iNBR56Nbt5ZJeQ'
	const CARSALES_CODE = 'dNdhhcT4rWcpPY7B'
	const ERIN_LIVING_CODE = 'ZKVkK5KzD5H3APdY'

	const validCodes = [CARBAR_CODE, CARSALES_CODE, ERIN_LIVING_CODE]

	const { partnerName } = useGetPartnerName({ route: to })
	const isPartnerSubRoute = !!partnerName.value

	let expectedCodeForThisRoute = CARBAR_CODE // Fallback to carbar

	if (isPartnerSubRoute) {
		switch (partnerName.value) {
			case 'carsales':
				expectedCodeForThisRoute = CARSALES_CODE
				break

			case 'erinliving':
				expectedCodeForThisRoute = ERIN_LIVING_CODE
				break

			default:
				expectedCodeForThisRoute = CARBAR_CODE
				break
		}
	}

	if (import.meta.server) {
		const event = useRequestEvent()
		if (!event) return

		const affiliateCookie = getCookie(event, 'affiliate_ref')
		const hasAffiliateCookie = !!affiliateCookie

		const sharedRefState = useState<string | null>(
			'affiliate_ref_state',
			() => null
		)

		// If no cookie exists, evaluate the incoming query string parameters
		if (refCode) {
			const isValidRefCode = refCode === expectedCodeForThisRoute

			if (isValidRefCode) {
				// console.log(
				// 	'[Middleware Server] No cookies and ref code is valid. Proceed to save.'
				// )

				// Save as cookie. Cookie is used to to check
				// if user has visited the referral link before.
				setCookie(event, 'affiliate_ref', refCode, {
					path: '/',
					httpOnly: true,
					secure: process.env.NODE_ENV === 'production',
					sameSite: 'lax',
					maxAge: 60 * 60 * 24 * 7, // 7 days
				})

				sharedRefState.value = refCode

				// console.log(
				// 	'[Middleware Server] Cookie saved and state populated:',
				// 	refCode
				// )
			} else {
				// console.log(
				// 	'[Middleware Server] Invalid referral code format:',
				// 	refCode
				// )
				sharedRefState.value = null
			}
		}
		// Check if the cookie exists and validate cookie value.
		else if (hasAffiliateCookie) {
			const isValidCookie = affiliateCookie === expectedCodeForThisRoute

			if (isValidCookie) {
				sharedRefState.value = affiliateCookie
				// console.log(
				// 	'[Middleware Server] Skipped saving. State synced from existing cookie:',
				// 	affiliateCookie
				// )
			} else {
				// console.log(
				// 	'[Middleware Server] Invalid referral code format:',
				// 	affiliateCookie
				// )
				sharedRefState.value = null
			}
		}

		return
	}

	// Check for invalid code via client side,
	// if user deliberately key in incorrect code.
	if (import.meta.client && refCode) {
		if (!validCodes.includes(refCode)) {
			// console.log('[Middleware Client] Invalid referral code')

			Sentry.captureMessage('Invalid Referral Code Attempted', {
				level: 'warning',
				tags: {
					feature: 'referral-tracker',
					attempted_code: refCode,
				},
				extra: {
					fullUrl: window.location.href,
					referrerSite: document.referrer || 'Direct Traffic',
				},
			})
		}
		return
	}
})
